var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer user-simple-renderer py-1" },
    [
      _c("router-link", { attrs: { to: _vm.link } }, [
        _c("div", {
          staticClass: "identification-mask rounded",
          style: "background-image: url(" + _vm.getPicture + ")",
        }),
        _vm._v(" "),
        _c("span", { staticClass: "name" }, [_vm._v(_vm._s(_vm.object.name))]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }